// The hub marks an upload `inlineable` when it has a preview URL, but that
// flag only says a preview exists. The browser decides the rest: a type it
// cannot draw comes back with `Content-Disposition: attachment`. A frame
// pointed at such a URL makes the browser download the file as soon as the
// article opens, so the frame is drawn only for types a browser renders.
const PREVIEWABLE_MIME_PATTERNS: readonly RegExp[] = [
  /^application\/pdf$/i,
  /^text\//i,
  /^image\//i,
  /^audio\//i,
  /^video\//i,
];

/**
 * True when a document of this MIME type can open inside a frame or a tab
 * without starting a download. A missing type counts as not previewable: the
 * safer choice is the download card, which never opens anything by itself.
 */
export const canPreviewDocument = (mime?: string): boolean =>
  Boolean(
    mime && PREVIEWABLE_MIME_PATTERNS.some((pattern) => pattern.test(mime)),
  );
